// Fabrique de balisage. Toute valeur interpolée est échappée : une fiche ne peut pas
// injecter de script, quel que soit ce qu'on y a collé. Ce qui doit rester brut le dit.
const ECHAPPE: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export class Brut {
  readonly texte: string;
  constructor(texte: string) { this.texte = texte; }
}
export const brut = (texte: string) => new Brut(texte);
export const esc = (v: unknown) => String(v ?? '').replace(/[&<>"']/g, (c) => ECHAPPE[c]!);

export function h(parts: TemplateStringsArray, ...valeurs: unknown[]): Brut {
  let sortie = parts[0] ?? '';
  valeurs.forEach((v, i) => {
    sortie += (v instanceof Brut ? v.texte
      : Array.isArray(v) ? v.map((x) => (x instanceof Brut ? x.texte : esc(x))).join('')
      : v === null || v === undefined || v === false ? '' : esc(v)) + (parts[i + 1] ?? '');
  });
  return new Brut(sortie);
}

export const $ = <T extends HTMLElement = HTMLElement>(sel: string, dans: ParentNode = document) =>
  dans.querySelector<T>(sel);

export const valeur = (sel: string) => ($(sel) as HTMLInputElement | null)?.value.trim() ?? '';

export function peindre(cible: string, contenu: Brut): void {
  const noeud = $(cible);
  if (noeud) noeud.innerHTML = contenu.texte;
}

let minuteur: number | undefined;
export function mot(texte: string): void {
  const n = $('#mot');
  if (!n) return;
  n.textContent = texte;
  n.classList.add('on');
  clearTimeout(minuteur);
  minuteur = window.setTimeout(() => n.classList.remove('on'), 2800);
}

export const jour = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: '2-digit' }) : '—';

export const instant = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—';

export const euros = (n: number | null | undefined) =>
  n == null ? '—' : n.toLocaleString('fr-FR') + ' €';

/** Délégation d'événements : un seul écouteur pour tout l'écran, jamais de fuite. */
export function surClic(action: (nom: string, cible: HTMLElement, ev: MouseEvent) => void): void {
  document.addEventListener('click', (ev) => {
    const cible = (ev.target as HTMLElement | null)?.closest<HTMLElement>('[data-act]');
    if (cible?.dataset['act']) action(cible.dataset['act'], cible, ev);
  });
}

/** Le bloc d'attente : ce qui se passe, une barre indéterminée, et le temps écoulé. */
export const blocAttente = (titre: string, phrase: string): Brut => h`
  <div class="enc st">
    <div class="rang"><span class="sur">${titre}</span><span class="pousse"></span>
      <span class="pt sourd" id="chrono">0 s</span><span class="pulse"></span></div>
    <p style="margin-top:4px">${phrase}</p>
    <div class="attente" style="margin-top:12px"></div>
  </div>`;

/**
 * L'attente d'un traitement de modèle. La barre est indéterminée — on ne connaît pas la
 * durée, et en afficher une fausse serait pire que rien. Le chronomètre, lui, ne ment
 * pas : c'est lui qui distingue « ça travaille » de « c'est bloqué ».
 */
export function compteur(cible: string): () => void {
  const debut = Date.now();
  const battre = () => {
    const n = $(cible);
    if (n) n.textContent = `${Math.round((Date.now() - debut) / 1000)} s`;
  };
  battre();
  const minuterie = window.setInterval(battre, 1000);
  return () => clearInterval(minuterie);
}
